const Roles = {
  role_super_admin: { id: 'ROLE_SUPERADMIN' },
  role_admin: { id: 'ROLE_ADMIN' },
  role_editor: { id: 'ROLE_EDITOR' },
  role_viewer: { id: 'ROLE_VIEWER' },
};

export default Roles;



// WEBPACK FOOTER //
// ./src/utils/roles.js